import type { SafeAny } from '@/common/types';
import { createRouter, createWebHistory } from 'vue-router';

const routes: SafeAny[] = [
  {
    path: '/graphs/:id/:notch/:band/:epochSize/:epochSelected',
    name: 'EpochViewUnscored',
    component: () => import('../modules/epoch/feature')
  },
  {
    path: '/graphs/:id/:notch/:band/:epochSize/:epochSelected/:scoreSet',
    name: 'EpochView',
    component: () => import('../modules/epoch/feature')
  },
  {
    path: '/report/:id',
    name: 'ReportViewBasic',
    component: () => import('../modules/report/feature')
  },
  {
    path: '/report/:id/',
    name: 'ReportView',
    component: () => import('../modules/report/feature')
  },
  {
    path: '/report/:id/print',
    name: 'PrintReportView',
    component: () => import('../modules/report/feature').then((m) => m.PrintView)
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../modules/not-found/not-found.component.vue')
  }
];

export const router = createRouter({
  history: createWebHistory(),
  routes
});
